import {
  Network,
  FileText,
  DollarSign,
  Users,
  ShieldCheck,
  Globe,
  MessageSquare,
  FileSearch,
  type LucideIcon,
} from "lucide-react";

export interface Capability {
  icon: LucideIcon;
  title: string;
  description: string;
}

export const CAPABILITIES: Capability[] = [
  {
    icon: Network,
    title: "Architecture & engineering artifacts",
    description:
      "Architecture specifications, Draw.io/PNG/SVG diagrams, technical BOMs, implementation roadmaps, starter code, agent frameworks, and infrastructure-as-code templates.",
  },
  {
    icon: DollarSign,
    title: "Cost & business-value artifacts",
    description:
      "AWS cost analysis, optimization recommendations, multi-year TCO comparisons, interactive cost calculators, and Business Value Assessments.",
  },
  {
    icon: Users,
    title: "Customer & sales deliverables",
    description:
      "Meeting preparation briefs, follow-up emails, GTM one-pagers, executive strategy documents, Statements of Work, and Agentic Process Transformation stories.",
  },
  {
    icon: FileText,
    title: "RFP & partner artifacts",
    description:
      "RFP responses, Requirements Traceability Matrices, APN competency submission materials, and partner enablement documentation.",
  },
  {
    icon: ShieldCheck,
    title: "Governance & compliance artifacts",
    description:
      "Well-Architected gap assessments, security boundary validation, and compliance verification for frameworks such as HIPAA, PCI DSS, GDPR, and regional requirements.",
  },
  {
    icon: Globe,
    title: "Account context & iterative delivery",
    description:
      "Salesforce-enriched account intelligence, surgical edits to existing artifacts as requirements evolve, delta architecture analysis, and localized multilingual outputs for global accounts.",
  },
  {
    icon: MessageSquare,
    title: "Interactive & adaptive collaboration",
    description:
      "Guided requirement discovery through targeted clarifying questions, dynamic workflow pivots as customer priorities shift, and user-driven steering across any artifact path.",
  },
  {
    icon: FileSearch,
    title: "Multi-modal context & document synthesis",
    description:
      "Direct ingestion and analysis of existing architecture diagrams (Draw.io/PNG/SVG), customer RFP PDFs, legacy SOWs, and technical baseline documentation.",
  },
];
